export const noop = () => { /* noop */ };
